import { NetworkStatus } from "@apollo/client";

import { FilterLoadState } from "./types";

// Due to network status and fetch policies, we need to manually track fetch states
// instead of relying on query updates. This map helps track loading states accurately,
// as we can't simply observe async variable resets or fetches.
export const selectFilter = (
  id: string,
  setFiltersLoaded: React.Dispatch<
    React.SetStateAction<Record<string, FilterLoadState>>
  >,
  setEndReached: React.Dispatch<React.SetStateAction<boolean>>,
  setFilter: React.Dispatch<React.SetStateAction<string>>,
) => {
  setFiltersLoaded(prevState => {
    const currentLoadState = prevState[id] || FilterLoadState.NOT_LOADED;

    // Determine the next load state based on the current load state
    let nextLoadState: FilterLoadState;
    switch (currentLoadState) {
      case FilterLoadState.NOT_LOADED:
        nextLoadState = FilterLoadState.LOADING;
        break;
      case FilterLoadState.LOADING:
        nextLoadState = FilterLoadState.FINISHED_LOADING;
        break;
      case FilterLoadState.FINISHED_LOADING:
        return prevState; // Exit early if no update is needed
      default:
        nextLoadState = currentLoadState;
    }

    // Only update state if it has actually changed
    if (nextLoadState !== currentLoadState) {
      return {
        ...prevState,
        [id]: nextLoadState,
      };
    }
    return prevState; // No change
  });
  setEndReached(false);
  setFilter(id);
};

export const isLoading = (
  networkStatus: NetworkStatus,
  filterState: FilterLoadState | undefined,
) => {
  return (
    (networkStatus === NetworkStatus.loading ||
      networkStatus === NetworkStatus.setVariables ||
      networkStatus === NetworkStatus.refetch) &&
    filterState === FilterLoadState.LOADING
  );
};
